<template>
  <div class="container sv018">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>ご利用可能な金融機関</heading-one>

    <p>お借り入れ金額のお受取りや、ご返済金のお引落しにご利用いただける金融機関は以下のとおりです。</p>

    <!--<contents-card class="-orange _mb-10">-->
      <!--<div class="card-header">-->
        <!--<h3 class="heading -orange">ご利用可能時間</h3>-->
      <!--</div>-->
      <!--<div class="card-body _pt-md-30">-->
        <!--<div class="card-groups">-->
          <!--<div class="card-box">-->
            <!--<p class="txt01 _mb-sm-20"><span class="txt02 -orange">お借り入れ</span>8:00～14:59</p>-->
          <!--</div>-->
          <!--<div class="card-box">-->
            <!--<p class="txt01"><span class="txt02 -green">ご返済</span>8:00～14:59</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</contents-card>-->

    <section>
      <heading-two>主な金融機関</heading-two>

      <!--<div class="main-bank01 _mb-md-30 _mb-sm-10">-->
        <!--<div class="img-box _mr-md-20 _pr-sm-10">-->
          <!--<img src="@/assets/images/sv/sv018/img01.gif" class="img-fluid" alt="">-->
        <!--</div>-->
        <!--<div class="img-box _ml-md-20 _pl-sm-10">-->
          <!--<img src="@/assets/images/sv/sv018/img02.gif" class="img-fluid" alt="">-->
        <!--</div>-->
      <!--</div>-->

      <table-box class="_mb-md-120 _mb-sm-60">
        <table-body>
          <table-row>
            <table-data>auじぶん銀行</table-data>
            <table-data>三菱ＵＦＪ銀行</table-data>
            <table-data>三井住友銀行</table-data>
            <table-data>みずほ銀行</table-data>
            <table-data>ゆうちょ銀行</table-data>
            <table-data>りそな銀行</table-data>
            <table-data>埼玉りそな銀行</table-data>
            <table-data>セブン銀行</table-data>
          </table-row>
        </table-body>
      </table-box>

      <heading-two>地方銀行</heading-two>

      <card-groups class="_mb-md-120 _mb-sm-60">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-hokkaido class="-plus">
              <h3 class="heading">北海道・東北地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-hokkaido">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>北海道銀行</table-data>
                    <table-data>北洋銀行</table-data>
                    <table-data>青森銀行</table-data>
                    <table-data>みちのく銀行</table-data>
                    <table-data>秋田銀行</table-data>
                    <table-data>北都銀行</table-data>
                    <table-data>荘内銀行</table-data>
                    <table-data>山形銀行</table-data>
                    <table-data>きらやか銀行</table-data>
                    <table-data>岩手銀行</table-data>
                    <table-data>東北銀行</table-data>
                    <table-data>北日本銀行</table-data>
                    <table-data>七十七銀行</table-data>
                    <table-data>仙台銀行</table-data>
                    <table-data>東邦銀行</table-data>
                    <table-data>福島銀行</table-data>
                    <table-data>大東銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-kanto class="-plus">
              <h3 class="heading">関東地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-kanto">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>群馬銀行</table-data>
                    <table-data>東和銀行</table-data>
                    <table-data>足利銀行</table-data>
                    <table-data>栃木銀行</table-data>
                    <table-data>常陽銀行</table-data>
                    <table-data>筑波銀行</table-data>
                    <table-data>武蔵野銀行</table-data>
                    <table-data>千葉銀行</table-data>
                    <table-data>千葉興業銀行</table-data>
                    <table-data>京葉銀行</table-data>
                    <table-data>きらぼし銀行</table-data>
                    <table-data>東日本銀行</table-data>
                    <table-data>東京スター銀行</table-data>
                    <table-data>横浜銀行</table-data>
                    <table-data>神奈川銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-cyubu class="-plus">
              <h3 class="heading">中部地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-cyubu">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>第四北越銀行</table-data>
                    <table-data>大光銀行</table-data>
                    <table-data>山梨中央銀行</table-data>
                    <table-data>八十二銀行</table-data>
                    <table-data>長野銀行</table-data>
                    <table-data>北陸銀行</table-data>
                    <table-data>富山銀行</table-data>
                    <table-data>富山第一銀行</table-data>
                    <table-data>北國銀行</table-data>
                    <table-data>福井銀行</table-data>
                    <table-data>福邦銀行</table-data>
                    <table-data>静岡銀行</table-data>
                    <table-data>スルガ銀行</table-data>
                    <table-data>清水銀行</table-data>
                    <table-data>静岡中央銀行</table-data>
                    <table-data>大垣共立銀行</table-data>
                    <table-data>十六銀行</table-data>
                    <table-data>愛知銀行</table-data>
                    <table-data>名古屋銀行</table-data>
                    <table-data>中京銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-kansai class="-plus">
              <h3 class="heading">関西地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-kansai">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>三十三銀行</table-data>
                    <table-data>百五銀行</table-data>
                    <table-data>滋賀銀行</table-data>
                    <table-data>京都銀行</table-data>
                    <table-data>関西みらい銀行</table-data>
                    <table-data>池田泉州銀行</table-data>
                    <table-data>南都銀行</table-data>
                    <table-data>紀陽銀行</table-data>
                    <table-data>但馬銀行</table-data>
                    <table-data>みなと銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-cyugoku class="-plus">
              <h3 class="heading">中国地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-cyugoku">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>鳥取銀行</table-data>
                    <table-data>島根銀行</table-data>
                    <table-data>山陰合同銀行</table-data>
                    <table-data>中国銀行</table-data>
                    <table-data>トマト銀行</table-data>
                    <table-data>広島銀行</table-data>
                    <table-data>もみじ銀行</table-data>
                    <table-data>山口銀行</table-data>
                    <table-data>西京銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-shikoku class="-plus">
              <h3 class="heading">四国地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-shikoku">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>阿波銀行</table-data>
                    <table-data>徳島大正銀行</table-data>
                    <table-data>百十四銀行</table-data>
                    <table-data>香川銀行</table-data>
                    <table-data>伊予銀行</table-data>
                    <table-data>愛媛銀行</table-data>
                    <table-data>四国銀行</table-data>
                    <table-data>高知銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.chiho-kyusyu class="-plus">
              <h3 class="heading">九州・沖縄地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="chiho-kyusyu">
            <card-body>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>福岡銀行</table-data>
                    <table-data>筑邦銀行</table-data>
                    <table-data>西日本シティ銀行</table-data>
                    <table-data>北九州銀行</table-data>
                    <table-data>福岡中央銀行</table-data>
                    <table-data>佐賀銀行</table-data>
                    <table-data>佐賀共栄銀行</table-data>
                    <table-data>十八親和銀行</table-data>
                    <table-data>長崎銀行</table-data>
                    <table-data>肥後銀行</table-data>
                    <table-data>熊本銀行</table-data>
                    <table-data>大分銀行</table-data>
                    <table-data>豊和銀行</table-data>
                    <table-data>宮崎銀行</table-data>
                    <table-data>宮崎太陽銀行</table-data>
                    <table-data>鹿児島銀行</table-data>
                    <table-data>南日本銀行</table-data>
                    <table-data>琉球銀行</table-data>
                    <table-data>沖縄銀行</table-data>
                    <table-data>沖縄海邦銀行</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>
    </section>

    <section>
      <heading-two>その他（ネット銀行など）</heading-two>

      <table-box class="_mb-md-120 _mb-sm-60">
        <table-body>
          <table-row>
            <table-data>ソニー銀行</table-data>
            <table-data>住信SBIネット銀行</table-data>
            <table-data>イオン銀行</table-data>
            <table-data>GMOあおぞらネット銀行</table-data>
            <table-data>新生銀行</table-data>
            <table-data>ゆうちょ銀行</table-data>
          </table-row>
        </table-body>
      </table-box>
    </section>

    <section>
      <heading-two>信用金庫</heading-two>
      <p class="_mb-md-120">全国の信用金庫で、お借り入れ金額のお受取りや、ご返済金のお引落しにご利用可能です。</p>
    </section>

    <section>
      <heading-two>信用組合</heading-two>
      <card-groups class="_mb-md-120 _mb-sm-60">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-hokkaido class="-plus">
              <h3 class="heading">北海道、東北地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-hokkaido">
            <card-body>
              <p class="ttl">北海道</p>
              <table-box class="mb-10">
                <table-body>
                  <table-row>
                    <table-data>北央信用組合</table-data>
                    <table-data>札幌中央信用組合</table-data>
                    <table-data>函館商工信用組合</table-data>
                    <table-data>十勝信用組合</table-data>
                    <table-data>釧路信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">青森県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>青森県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">宮城県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>石巻商工信用組合</table-data>
                    <table-data>古川信用組合</table-data>
                    <table-data>仙北信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">秋田県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>秋田県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">山形県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>北郡信用組合</table-data>
                    <table-data>山形中央信用組合</table-data>
                    <table-data>山形第一信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">福島県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>福島県商工信用組合</table-data>
                    <table-data>いわき信用組合</table-data>
                    <table-data>相双五城信用組合</table-data>
                    <table-data>会津商工信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-kanto class="-plus">
              <h3 class="heading">関東地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-kanto">
            <card-body>
              <p class="ttl">茨城県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>茨城県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">栃木県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>真岡信用組合</table-data>
                    <table-data>那須信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">群馬県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>あかぎ信用組合</table-data>
                    <table-data>群馬県信用組合</table-data>
                    <table-data>ぐんまみらい信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">埼玉県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>熊谷商工信用組合</table-data>
                    <table-data>埼玉信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">千葉県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>房総信用組合</table-data>
                    <table-data>銚子商工信用組合</table-data>
                    <table-data>君津信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">東京都</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>あすか信用組合</table-data>
                    <table-data>全東栄信用組合</table-data>
                    <table-data>東京厚生信用組合</table-data>
                    <table-data>東信用組合</table-data>
                    <table-data>江東信用組合</table-data>
                    <table-data>青和信用組合</table-data>
                    <table-data>中ノ郷信用組合</table-data>
                    <table-data>共立信用組合</table-data>
                    <table-data>七島信用組合</table-data>
                    <table-data>大東京信用組合</table-data>
                    <table-data>第一勧業信用組合</table-data>
                    <table-data>警視庁職員信用組合</table-data>
                    <table-data>東京消防信用組合</table-data>
                    <table-data>東京都職員信用組合</table-data>
                    <table-data>ハナ信用組合</table-data>
                    <table-data>朝日新聞信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">神奈川県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>神奈川県医師信用組合</table-data>
                    <table-data>神奈川県歯科医師信用組合</table-data>
                    <table-data>横浜幸銀信用組合</table-data>
                    <table-data>信用組合横浜華銀</table-data>
                    <table-data>小田原第一信用組合</table-data>
                    <table-data>相愛信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-cyubu class="-plus">
              <h3 class="heading">中部地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-cyubu">
            <card-body>
              <p class="ttl">新潟県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>新潟縣信用組合</table-data>
                    <table-data>新潟鉄道信用組合</table-data>
                    <table-data>興栄信用組合</table-data>
                    <table-data>はばたき信用組合</table-data>
                    <table-data>協栄信用組合</table-data>
                    <table-data>三條信用組合</table-data>
                    <table-data>巻信用組合</table-data>
                    <table-data>新潟大栄信用組合</table-data>
                    <table-data>糸魚川信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">山梨県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>山梨県民信用組合</table-data>
                    <table-data>都留信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">長野県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>長野県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">富山県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>富山県医師信用組合</table-data>
                    <table-data>富山県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">石川県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>金沢中央信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">福井県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>福泉信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">愛知県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>信用組合愛知商銀</table-data>
                    <table-data>愛知県警察信用組合</table-data>
                    <table-data>豊橋商工信用組合</table-data>
                    <table-data>愛知県中央信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">岐阜県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>岐阜商工信用組合</table-data>
                    <table-data>イオ信用組合</table-data>
                    <table-data>飛騨信用組合</table-data>
                    <table-data>益田信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-kansai class="-plus">
              <h3 class="heading">関西地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-kansai">
            <card-body>
              <p class="ttl">滋賀県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>滋賀県民信用組合</table-data>
                    <table-data>滋賀県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">京都府</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>京滋信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">大阪府</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>大同信用組合</table-data>
                    <table-data>成協信用組合</table-data>
                    <table-data>大阪貯蓄信用組合</table-data>
                    <table-data>のぞみ信用組合</table-data>
                    <table-data>大阪府医師信用組合</table-data>
                    <table-data>大阪府警察信用組合</table-data>
                    <table-data>近畿産業信用組合</table-data>
                    <table-data>ミレ信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">兵庫県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>兵庫県警察信用組合</table-data>
                    <table-data>兵庫県医療信用組合</table-data>
                    <table-data>兵庫県信用組合</table-data>
                    <table-data>淡陽信用組合</table-data>
                    <table-data>兵庫ひまわり信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-cyugoku class="-plus">
              <h3 class="heading">中国地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-cyugoku">
            <card-body>
              <p class="ttl">島根県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>島根益田信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">岡山県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>朝銀西信用組合</table-data>
                    <table-data>笠岡信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">広島県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>広島市信用組合</table-data>
                    <table-data>広島県信用組合</table-data>
                    <table-data>信用組合広島商銀</table-data>
                    <table-data>両備信用組合</table-data>
                    <table-data>備後信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">山口県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>山口県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-shikoku class="-plus">
              <h3 class="heading">四国地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-shikoku">
            <card-body>
              <p class="ttl">香川県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>香川県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">高知県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>土佐信用組合</table-data>
                    <table-data>宿毛商銀信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.rokin-kyusyu class="-plus">
              <h3 class="heading">九州、沖縄地方</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="rokin-kyusyu">
            <card-body>
              <p class="ttl">福岡県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>福岡県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">佐賀県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>佐賀東信用組合</table-data>
                    <table-data>佐賀西信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">長崎県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>長崎三菱信用組合</table-data>
                    <table-data>西海みずき信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">熊本県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>熊本県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">大分県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>大分県信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">宮崎県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>宮崎県南部信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
            <card-body>
              <p class="ttl">鹿児島県</p>
              <table-box>
                <table-body>
                  <table-row>
                    <table-data>鹿児島興業信用組合</table-data>
                    <table-data>奄美信用組合</table-data>
                  </table-row>
                </table-body>
              </table-box>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>
    </section>

    <section>
      <heading-two>労働金庫</heading-two>
      <table-box class="_mb-md-120 _mb-sm-60">
        <table-body>
          <table-row>
            <table-data>北海道労働金庫</table-data>
            <table-data>東北労働金庫</table-data>
            <table-data>中央労働金庫</table-data>
            <table-data>新潟県労働金庫</table-data>
            <table-data>長野県労働金庫</table-data>
            <table-data>静岡県労働金庫</table-data>
            <table-data>北陸労働金庫</table-data>
            <table-data>東海労働金庫</table-data>
            <table-data>近畿労働金庫</table-data>
            <table-data>中国労働金庫</table-data>
            <table-data>四国労働金庫</table-data>
            <table-data>九州労働金庫</table-data>
            <table-data>沖縄県労働金庫</table-data>
          </table-row>
        </table-body>
      </table-box>
      <div class="_textright">
        <small>※2023年4月10日時点</small>
      </div>

    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <list-group class="-note">
        <list-item class="-note">以下の金融機関は、お申し込み時にはご登録いただけません。
          <list-group>
            <list-item class="-note">新生銀行・愛知銀行・農業協同組合</list-item>
          </list-group>
        </list-item>
        <list-item class="-note">金融機関の口座は、新規お申し込み時、または、ご契約後に会員さま専用サイトにてご登録いただけます。</list-item>
        <list-item class="-note">ご契約後にご登録される場合は、会員さま専用サイトにログインのうえ「口座情報の登録・変更」よりお手続きください。</list-item>
      </list-group>
      <list-group class="-link">
        <list-item class="-link" routerName="ce001">「口座情報の登録・変更」はこちら</list-item>
      </list-group>
    </section>

    <cv-box class="_mb-md-120 _mb-sm-60"/>

    <contact-box class="_mb-md-120 _mb-sm-60"/>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import ContentsHeader from '../components/contents/ContentsHeader'
import ContentsIntro from '../components/contents/ContentsIntro'
import ContentsCard from '../components/contents/ContentsCard'
import BtnToggle from '../components/button/BtnToggle'
import CardGroup from 'bootstrap-vue/es/components/card/card-group'
import CardGroups from '../components/card/CardGroups'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CollapseItem from '../components/collapse/CollapseItem'
import CvBox from '../components/box/CvBox'
import ContactBox from '../components/box/ContactBox'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtnText from '../components/button/BtnText'

export default {
  name: 'Sv-018',
  metaInfo: {
    title: 'ご利用可能な金融機関｜お申し込み条件・お手続きの流れ',
    meta: [
      {name: 'description', content: 'au PAY スマートローンでご利用可能な金融機関についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お申込み,金融機関,銀行'}
    ]
  },
  components: {
    BtnText,
    ListItem,
    ListGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    ContactBox,
    CvBox,
    CollapseItem,
    CardBody,
    CardHeader,
    CardBox,
    CardGroups,
    CardGroup,
    BtnToggle,
    ContentsHeader,
    ContentsIntro,
    ContentsCard,
    HeadingOne,
    HeadingTwo
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'お申し込み条件・お手続きの流れ',
        routerName: 'sv045'
      },
      {
        text: 'ご利用可能な金融機関',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

  .contents-card {
    >.card-body {
      background-color: #fff;
      border-radius: 10px;
      padding: 25px;
      @include mq-up(md) {
        padding: 30px 50px;
      }
      >.card-groups {
        display: flex;
          @include mq-down(md) {
            flex-wrap: wrap;
          }
          @include mq-up(md) {
            justify-content: space-between;
            align-items: center;
          }
        >.card-box {
            width: 100%;
          @include mq-up(md) {
            width: 50%;
          }
          >.txt01 {
            font-size: 20px;
            word-break:break-all;
            text-align: center;
            margin-bottom: 0;
            @include mq-down(md) {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            @include mq-up(md) {
              font-size: 24px;
            }
            >.txt02 {
              padding-top: 5px;
              padding-bottom: 5px;
              max-width: 100px;
              width: 100%;
              display: inline-block;;
              font-size: 14px;
              color: #fff;
              border-radius: 5px;
              margin-right: 20px;
              @include mq-up(md) {
                max-width: 140px;
                margin-right: 30px;
                font-size: 16px;
              }
            }
            >.-orange {
              background-color: $orange;
            }
            >.-green {
              background-color: $green;
            }
          }
        }
      }
    }
  }
  .main-bank01 {
    display: flex;
    justify-content: center;
    .img-box {
      width: 50%;
      @include mq-up(md) {
        max-width: 270px;
        width: 100%;
      }
    }
  }
  .main-bank02 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    @include mq-down(md) {
      flex-wrap: wrap;
    }
    @include mq-up(md) {
      margin-bottom: 120px;
    }
    .img-box {
      width: 50%;
      @include mq-up(md) {
        max-width: 270px;
        width: 100%;
      }
    }
  }

  .ttl {
    font-weight: bold;
  }

  .table-box {
    table-layout:fixed;
    border: 0 !important;
   >.table-body {
     >.table-row {
       display: flex;
       flex-wrap: wrap;
       >.table-data {
         width: 100%;
         max-width: 50%;
         text-align: center;
         padding: 15px 20px;
         border: 1px solid #cccccc !important;
         margin-left: -1px;
         margin-bottom: -1px;
         display: flex;
         align-items: center;
         justify-content: center;
         @include mq-up(md) {
           padding: 25px 20px;
           max-width: 16.75%;
         }
       }
     }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Sv018.vue